import ImagesSlider from 'assets/core/js/module/imagesSlider'

export default {
  init: function (): void {
    document.querySelectorAll<HTMLElement>('.result__image .slider').forEach(function (el) {
      ImagesSlider(el, {
        pagination: {
          el: '.slider-pagination',
          type: 'custom',
          renderCustom: function (current: number, total: number) {
            return `${current}/${el.hasAttribute('data-total-images') ? (el.getAttribute('data-total-images') as string) : total}`
          },
        },
        spaceBetween: 10,
      })
    })
  },
}
